import { createContext, useContext } from 'react';

const CustomerSuccessSearchContext = createContext();

CustomerSuccessSearchContext.displayName = 'CustomerSuccessSearchContext';

const useCustomerSuccessSearch = () => useContext(CustomerSuccessSearchContext);

export { CustomerSuccessSearchContext, useCustomerSuccessSearch };
